var exports = {
  "TT": "ProfileCardUserInfo.module__userInfoContainer___eUNyZ3",
  "S7": "ProfileCardUserInfo.module__nameRow___eUNyZ3",
  "oo": "ProfileCardUserInfo.module__nameButton___eUNyZ3",
  "uV": "ProfileCardUserInfo.module__nameButtonClickable___eUNyZ3",
  "fC": "ProfileCardUserInfo.module__badgeContainer___eUNyZ3",
  "CQ": "ProfileCardUserInfo.module__verifiedBadge___eUNyZ3",
  "NW": "ProfileCardUserInfo.module__userTagWrapper___eUNyZ3",
  "Hq": "ProfileCardUserInfo.module__actionsContainer___eUNyZ3",
  "Fj": "ProfileCardUserInfo.module__usernameRow___eUNyZ3",
  "xO": "ProfileCardUserInfo.module__usernameButton___eUNyZ3",
  "hI": "ProfileCardUserInfo.module__pronouns___eUNyZ3",
  "sM": "ProfileCardUserInfo.module__srOnly___eUNyZ3",
};

module.exports = exports;
